import type { AffectedWorkPackage, BulkDeletePreview } from '@/common/soft-delete';

export type BulkDamageDeletePlan = {
	/** Ids that are deleted when the user confirms */
	deletableIds: string[];
	/** Damages that cannot be deleted, with the work packages that record them */
	blocked: { id: string; workPackages: AffectedWorkPackage[] }[];
	/** Selected ids the user can no longer delete (already deleted, or not theirs) */
	unavailableIds: string[];
};

/**
 * What a bulk delete of damages will do, from the bulk delete preview (GH #331): damages recorded in a
 * work package, whatever its status, are left out and the others go ahead. Without a preview (still loading, or it failed) every selected damage is tried; the backend still
 * refuses the blocked ones.
 */
export function planBulkDamageDelete(
	selectedIds: string[],
	preview: BulkDeletePreview | undefined,
): BulkDamageDeletePlan {
	if (!preview) {
		return { deletableIds: selectedIds, blocked: [], unavailableIds: [] };
	}
	const blocked: BulkDamageDeletePlan['blocked'] = [];
	const deletableIds: string[] = [];
	for (const item of preview.items) {
		const blocker = item.blockedBy.find((entry) => entry.code === 'DAMAGE_IN_WORK_PACKAGE');
		if (item.blockedBy.length > 0) {
			blocked.push({
				id: item.id,
				workPackages: item.workPackages.filter((workPackage) => blocker?.workPackageIds?.includes(workPackage.id)),
			});
			continue;
		}
		deletableIds.push(item.id);
	}
	return {
		// Keep the selection's order
		deletableIds: selectedIds.filter((id) => deletableIds.includes(id)),
		blocked,
		unavailableIds: preview.unavailable,
	};
}
